import React from 'react'
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import { connect } from "react-redux";

import Dialog from '../Dialog';
import TotalDueNow from '../TotalDueNow';
import Currency from '../Currency';
import SpotlioButton from '../Button';
import QuantitySelector from '../QuantitySelector';
import SpotlioIcon from '../Icon';

import { setItineraryId, getSystemSettings } from '../../utils/SettingsRetriever';
import PushHistory from '../../utils/PushHistory';
import getDateFormat from "../../utils/DateFormatRetriever";

import { getItinerary as globalGetItinerary, addPackage as globalAddPackage, remove as globalRemove } from '../../services/cart';

import IntlMessage from '../../LocaleEngine';
import LocaleAsString from "../../LocaleEngine/LocaleAsString";

import './index.scss';

class SummaryCart extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            cart:[],
            total: 0,
            taxes: 0,
            loading:!this.props.loading ? true : this.props.loading,
            quantity:0,
            deletedItem:{},
            removeItemModal: false,
            savings: 0,
            depostit_schedule: true,
            subLoading: false,
            highlightedItineraryItems: [],
            auxIdx: undefined,
            firstLoad: true,
            itineraryId: undefined,
            errorModal: false,
            differentPackagesDiag: false,
            amountToDelete: undefined
        }
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.loading ===  true && this.state.loading === false){
            this.setState({loading: nextProps.loading})
        }
        if (nextProps.loading === 'finished' && this.props.loading !== 'finished'){
            this.getItinerary('add');
        }
        if (nextProps.savings !== this.state.savings){
            this.setState({savings: nextProps.savings})
        }
        if (nextProps.total !== this.state.total && nextProps.total !== undefined){
            this.setState({total: nextProps.total})
        }
    }

    componentDidMount(){
        this.props.isPackage ?
            this.setState({cart: this.props.cart, loading: false, savings: this.props.savings})
        :
        this.getItinerary();
    }

    removeItemModalOpen = (item, value) => {
        this.setState({deletedItem: item}, () => {
            this.setState({removeItemModal: value, amountToDelete: undefined })
        })
    }

    addItemsToCart = () => {
        this.setState({subLoading: true})
        let form = this.props.form.lodging;
        let itineraryItems = [];
        // let lengthToAdd = 0;

        if(form.adults === null) form.adults = 1;
        if(form.children === null) form.children = 0;

        this.state.cart.forEach((item) => {
            if (getSystemSettings().app && getSystemSettings().app.cart && getSystemSettings().app.cart.add && getSystemSettings().app.cart.add.mode === "grouped"){
            let itineraryItem = {
                ArrivalDate: item.ProductCategoryId === 1 ? moment.utc(new Date(form.arrivalDate)).format("YYYY-MM-DD") : item.arrivalDate,
                DepartureDate: item.ProductCategoryId === 1 ? moment.utc(new Date(form.departureDate)).format("YYYY-MM-DD") : item.arrivalDate,
                AdultCount: item.ProductCategoryId === 1 ? form.adults : 1,
                ChildCount: item.ProductCategoryId === 1 ? form.children : 0,
                SupplierId: item.SupplierId,
                ProductId: item.ProductId,
                Quantity: item.Quantity,
                PackageComponentId: item.PackageComponentId
            }
            itineraryItems.push(itineraryItem)
            } else {
                for (let i=0; i<item.Quantity; i++){
                    let itineraryItem = {
                        ArrivalDate: item.ProductCategoryId === 1 ? moment.utc(new Date(form.arrivalDate)).format("YYYY-MM-DD") : item.arrivalDate,
                        DepartureDate: item.ProductCategoryId === 1 ? moment.utc(new Date(form.departureDate)).format("YYYY-MM-DD") : item.arrivalDate,
                        AdultCount: item.ProductCategoryId === 1 ? form.adults : 1,
                        ChildCount: item.ProductCategoryId === 1 ? form.children : 0,
                        SupplierId: item.SupplierId,
                        ProductId: item.ProductId,
                        Quantity: 1,
                        PackageComponentId: item.PackageComponentId
                    }
                    itineraryItems.push(itineraryItem)
                    // lengthToAdd++
                }
            }
        })

        globalAddPackage({
            itineraryitems: JSON.stringify(itineraryItems),
            packageId: this.props.packageId
        })
        .then(response =>{
            // setCartLength(getCartLength() + lengthToAdd)
            this.setState({subLoading:false, differentPackagesDiag: false})
            setItineraryId(response.ItineraryId)
            response.UpsellItemList !== "" && response.UpsellItemList !== null ? this.props.getBundle(response.UpsellItemList) : PushHistory('/shopping-cart/review')
            // this.props.getBundle(3)
        })
    }

    purgeCart = () => {
        let itemCounter = 0;
        let deletedCounter = 0;
        globalGetItinerary({group: 0, bundle: 0})
        .then( (data) => {
            data.items.forEach(product => {
                if(product.supercategoryid === 0){
                    product.items.forEach(item => {
                        itemCounter++;
                        globalRemove({
                            itemId: item.ItineraryItemId
                        })
                        .then( () => {
                            deletedCounter++;
                            if (deletedCounter === itemCounter) this.addPackage();
                        });
                    })
                }
            })
        });
    }

    addPackage = () => {
        this.setState({...this.state, subLoading: true}, () => {
        if (this.props.checkRequired()){
                if (this.props.allowMultiplePackages === false) {
                    globalGetItinerary({ bundle: 0})
                    .then( (data) => {
                        if (!data.selectedPackage || data.selectedPackage === 99){ // put a 99 as a command from Arnau
                            this.addItemsToCart();
                        }

                        if(data.selectedPackage && data.selectedPackage.PackageId > 0){
                            this.setState({
                                ...this.state,
                                differentPackagesDiag: true,
                                subLoading: false
                            });
                        }
                    });
                } else {
                    this.addItemsToCart();
                }
            } else {
                this.setState({subLoading:false, errorModal: true})
            }
        })
    }

    getItinerary = (action = false) => {
        let state = this.state;
        let params = { bundle: 0};

        if(action === 'delete' || action === 'add'){
            params.reload = true;

            if(action === 'delete'){
                state.deletedItem = {};
                state.removeItemModal = false;
                state.amountToDelete = undefined;
            }
        }

        globalGetItinerary(params)
        .then( (data) => {
            state.itineraryId = data.itineraryid;
            state.highlightedItineraryItems = [];

            let cartDifferences = [];
            if(data && data.items){
                let currentItems = [];
                let incomingItems = [];
                state.cart.forEach(idx => idx.items.forEach(jdx => {
                    currentItems.push(jdx.ItineraryItemId);
                }));
                data.items.forEach(idx => idx.items.forEach(jdx => {
                    incomingItems.push(jdx.ItineraryItemId);
                }));

                cartDifferences = incomingItems.filter(function(obj) { return currentItems.indexOf(obj) === -1; });

                if (cartDifferences.length > 0 && !state.firstLoad) {
                    state.highlightedItineraryItems = cartDifferences;
                } else {
                    state.firstLoad = false;
                }
    
                state.cart = data.items;
    
                const taxes = data.fees;
                let taxesfees = 0
                let total = 0
                let quantity = 0
                let savings = 0
                data.items.forEach((agrupation, idx) => {
                    agrupation.items.forEach((item) => {
                        savings += parseFloat(item.OriginalPrice - item.Price)
                        total += parseFloat(item.Price);
                        quantity += item.Quantity;
                    })
                });
                if (taxes){
                    taxes.forEach((tax) => {
                        tax.Amount ? taxesfees += tax.Amount : taxesfees += tax.price;
                    });
                }
    
                state.savings = savings;
                state.total = total;
                state.fees = taxesfees;
                state.loading = false;
                state.quantity = quantity;
            }

            this.setState(state);
        })
    }

    openModal = (item, idx) => {
        if (idx !== undefined){
            this.setState({deletedItem: item, auxIdx: idx, amountToDelete: item.Quantity > 1 ? 1 : undefined}, ()=> {
                this.setState({removeItemModal:true})
            })
        } else {
            this.setState({deletedItem: item, amountToDelete: item.Quantity > 1 ? 1 : undefined}, ()=>{
                this.setState({removeItemModal:true})
            })
        }

    }

    getQuantityPackage = () => {
        let quantity = 0
        this.state.cart.forEach((item) => {
            quantity += item.Quantity
        })
        return quantity;
    }

    handleDeleteItem = (quantity) => {
        // eslint-disable-next-line
        if ( typeof CustomEvent !== "function" ) CustomEvent = ( event, params ) => {
            params = params || { bubbles: false, cancelable: false, detail: null };
            var evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }
        var triggerDeleteItemFromSummaryCart = new CustomEvent("triggerDeleteItemFromSummaryCart");

        this.setState({loading: true})
        if (quantity){
            for (let i = 0; i < quantity; i++){
                globalRemove({
                    itemId: this.state.deletedItem.ItineraryItemsIds[i]
                })
                .then( () => {
                    document.dispatchEvent(triggerDeleteItemFromSummaryCart);
                });
            }
            this.getItinerary('delete');
            // this.removeItemModalOpen({}, false);
            // setCartLength(getCartLength() - this.state.deletedItem.Quantity)
        } else {
            globalRemove({
                itemId: this.state.deletedItem.ItineraryItemId
            })
            .then( () => {
                document.dispatchEvent(triggerDeleteItemFromSummaryCart);
                // setCartLength(getCartLength() - this.state.deletedItem.Quantity)
                // this.removeItemModalOpen({}, false);
                this.getItinerary('delete');
            }).catch(err => console.error('nah'));
        }
    }

    bundleDeletePackage = (idx, amount) => {
        this.props.deleteFromCart(idx, amount)
        this.setState({removeItemModal: false, amountToDelete: undefined})
    }

    getCurrency = (item) => {
        let currency = null;
        switch(item.DisplayType){
            case 1:
                currency = (
                    <Currency displayType={item.DisplayType} value={item.OriginalPrice} float={true} onlyOriginal={true} strikeThrough={true} />
                )
            break;
            case 2:
                currency = (
                    <div className="itemizeAndShow">
                        {item.OriginalPrice !== item.Price ? <Currency displayType={item.DisplayType} value={item.OriginalPrice} float={true} onlyOriginal={true} strikeThrough={true} /> : null}
                        <Currency value={item.Price} float={true} />
                    </div>
                )
            break;
            case 3:
            break;
            default:
            break;
        }
        return currency
    }

    checkModal = (value) => {
        this.setState({errorModal: value})
    }

    handleRenderSideBanner = () => {
        if (!this.props.config || !this.props.config.sideBanner) return null;
        else {
            let banner = null;
            switch(this.props.config.sideBanner.type) {
                case 'image':
                    banner = <img alt="Side Banner" className="SideBanner" src={this.props.config.sideBanner.url} />;
                    break;
                default:
                    break;
            }
            return <div className="BannerWrapper">{banner}</div>
        }
    }

    renderLodgingItem = (idx, item) => {
        return (
            <div key={"item"+idx} className="product">
                <div className="item">
                    <div className="content">
                        <div className="names">
                            <div className="supplierName">{item.LocationName}</div>
                            <div className="productName">{item.ProductName}</div>
                        </div>
                        <div className="dateqty">
                            <div className="option date">
                                <label>Arrival Date</label>
                                {
                                    item.ArrivalDate 
                                    ? moment.utc(item.ArrivalDate).format(getDateFormat())
                                    : moment.utc(this.props.form.lodging.arrivalDate).format(getDateFormat())
                                }
                            </div>
                            <div className="option date">
                                <label>Departure Date</label>
                                {
                                    item.DepartureDate 
                                    ? moment.utc(item.DepartureDate).format(getDateFormat())
                                    : moment.utc(this.props.form.lodging.departureDate).format(getDateFormat())
                                }
                            </div>
                            <div className="option date">
                                <label>Adults</label>
                                {this.props.form.lodging.adults}
                            </div>
                            {this.props.form.lodging.children ?
                            <div className="option date">
                                <label>Children</label>
                                {this.props.form.lodging.children}
                            </div> : null}
                        </div>
                        <div className="bottom">
                            <div className="remove">
                            {
                                this.props.boolean === true
                                ?
                                null
                                :
                                <SpotlioIcon icon={"feather-trash-2"} onClick={() => this.openModal(item, idx)} size={16} />
                            }
                            </div>
                            <div className="price">
                                {this.getCurrency(item)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render(){
        if (this.state.cart.length <= 0) {
            return (
                <React.Fragment>
                <div className="summaryCart">
                    <div className="noItems">
                        <SpotlioIcon icon={"feather-shopping-cart"} size={64} />
                        <span>No items added to cart</span>
                    </div>
                </div>
                { this.handleRenderSideBanner() }
                <div style={{backgroundColor: "gray"}} className="mobileCart">
                    <div className="shoppingCart"><SpotlioIcon icon={"feather-shopping-cart"} /></div>
                    <div className="noresults">No items added to cart</div>
                </div>
                </React.Fragment>
            );
        }
        return (
            <React.Fragment>
                <div className="summaryCart">
                    {
                        this.state.loading
                        ?
                        <div className="loading">
                            <CircularProgress />
                        </div>
                        :
                        null
                    }
                    <div className={'container' + (this.state.loading === true ? ' blur' : '')}>
                        {
                            this.props.isPackage ?
                            <div className="header">
                                <span className="packageName">{this.props.packageName}</span>
                                <span>My package</span>
                            </div>
                            :
                            <div className="topBar">
                                <div className="total">
                                    TOTAL:
                                </div>
                                <Currency value={this.state.total + this.state.fees} float={true} />
                            </div>
                        }
                        <div className="products">
                            {
                                !this.props.isPackage ?
                                    this.state.cart.map((agrupation, idx) => {
                                        return (
                                            <div className="agrupation" key={idx}>
                                                <div className="header">
                                                    {agrupation.name}
                                                </div>
                                                {
                                                    agrupation.items.map((item, idx) => {
                                                        let className = "product";
                                                        if (this.state.highlightedItineraryItems.indexOf(item.ItineraryItemId) >= 0) {
                                                            className += " highlight";
                                                        }
                                                        return(
                                                            (item.CategoryId === 1 || item.ProductCategoryId === 1) ?
                                                                this.renderLodgingItem(idx, item)
                                                            : (
                                                                <div key={"item"+idx} className={className}>
                                                                    <div className="item">
                                                                        <div className="content">
                                                                            <div className="names">
                                                                                <div className="supplierName">{item.LocationName}</div>
                                                                                <div className="productName">{item.ProductName}</div>
                                                                            </div>
                                                                            <div className="dateqty">
                                                                                <div className="option date">
                                                                                    <label>Date</label>
                                                                                    {moment.utc(item.ArrivalDate).format(getDateFormat())}
                                                                                </div>
                                                                            </div>
                                                                            <div className="bottom">
                                                                                <div className="remove">
                                                                                {
                                                                                    this.props.boolean !== true && item.PackageRequiredItem === 0 && !item.NoDelete
                                                                                    ?
                                                                                    <SpotlioIcon icon={"feather-trash-2"} onClick={() => this.openModal(item, idx)} size={16} />
                                                                                    :
                                                                                    null
                                                                                }
                                                                                </div>
                                                                                <div className="price">
                                                                                    <div className="quantity">x {item.Quantity}</div>
                                                                                    <Currency value={item.Price} float={true} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        )
                                                    })
                                                }
                                            </div>
                                        )
                                    })
                                :
                                this.state.cart.map((item, idx) => {
                                    return (
                                    (item.CategoryId === 1 || item.ProductCategoryId === 1) ?
                                        this.renderLodgingItem(idx, item)
                                    :
                                    <div key={"item"+idx} className="product">
                                        <div className="item">
                                            <div className="content">
                                                <div className="names">
                                                    <div className="supplierName">{item.LocationName}</div>
                                                    <div className="productName">{item.ProductName}</div>
                                                </div>
                                                <div className="dateqty">
                                                    <div className="option date">
                                                        <label>Date</label>
                                                        {moment.utc(item.arrivalDate).format(getDateFormat())}
                                                    </div>
                                                </div>
                                                <div className="bottom">
                                                    <div className="remove">
                                                    {
                                                        this.props.boolean !== true
                                                        ?
                                                        <SpotlioIcon icon={"feather-trash-2"} onClick={() => this.openModal(item, idx)} size={16} />
                                                        :
                                                        null
                                                    }
                                                    </div>
                                                    <div className="price">
                                                        <div className="quantity">x {item.Quantity}</div>
                                                        {this.getCurrency(item)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                })
                            }
                        </div>
                        {
                            this.props.isPackage ?
                            <div className="bottomCart">
                                {this.props.savings ? <div className="summaryLine subtotal"><div className="label">Subtotal</div><div className="value"><Currency value={this.props.savings + this.props.total} float={true}/></div></div> : null}
                                <div className="summaryLine total">
                                    <div className="label">
                                        Total
                                    </div>
                                    <div className="value">
                                        <Currency value={this.props.total} float={true} />
                                    </div>
                                </div>
                                {this.props.savings ? <div className="summaryLine savings"><div className="label"><IntlMessage id="cart.labels.savings" /></div><div className="value"><Currency value={this.props.savings} float={true}/></div></div> : null}
                                <SpotlioButton callBack={()=>this.addPackage()} loading={this.state.subLoading} className={'footer isPackage'}>
                                    {
                                        getSystemSettings().app && getSystemSettings().app && getSystemSettings().app.removePackageWord ?
                                        "Add to cart"
                                        :
                                        "Add package to cart"
                                    }
                                </SpotlioButton>
                            </div>
                            :
                            <React.Fragment>
                                <div className="summary">
                                    {this.state.savings > 0 ? <div className="summaryLine savings"><div className="label"><IntlMessage id="cart.labels.savings" /></div><div className="value"><Currency value={this.state.savings} float={true}/></div></div> : null}
                                    {this.props.isPackage ? null : <div className="summaryLine subtotal"><div className="label">Subtotal</div><div className="value"><Currency value={this.state.total} float={true}/></div></div> }
                                    {this.state.fees > 0 ? <div className="summaryLine taxes"><div className="label">Taxes & fees</div><div className="value"><Currency value={this.state.fees} float={true}/></div></div> : null}

                                    <div className="summaryLine total">
                                        <div className="label">
                                            Total
                                        </div>
                                        <div className="value">
                                            <Currency value={this.props.isPackage ? this.props.total : this.state.total + this.state.fees} float={true} />
                                        </div>
                                    </div>
                                    {this.state.depostit_schedule && !this.props.isPackage ? <TotalDueNow base={this.state.total} applyBorder={true} /> : null}
                                </div>
                                {
                                    this.props.boolean === true
                                    ?
                                    null
                                    : (
                                        <Button onClick={()=>{PushHistory('/shopping-cart/review')}} className="footer button">
                                            GO TO CART
                                        </Button>
                                    )
                                }
                                <div className="bottomItineraryId">Itinerary Ref. #{this.state.itineraryId}</div >
                            </React.Fragment>
                        }
                    </div>
                </div>
                { this.handleRenderSideBanner() }
                <div className="mobileCart">
                    {this.state.loading ?

                    <div className="loading">
                        <CircularProgress />
                    </div>
                    :
                    <React.Fragment>
                        <div className="shoppingCart">
                            <div className="count">{this.props.isPackage ? this.getQuantityPackage() : this.state.quantity} item(s) {this.props.isPackage ? " selected" : " in cart"}</div>
                            <Currency onlyOriginal={true} float={true} value={this.props.isPackage ? this.state.total : this.state.total + this.state.fees} />
                        </div>
                        <div className="right">
                            <SpotlioButton callBack={this.props.isPackage ? this.props.toggleCartDialog ? ()=>this.props.toggleCartDialog() : ()=>this.addPackage() : ()=>{PushHistory('/shopping-cart/review')}} loading={this.state.subLoading}  className={'footer'}>
                                {this.props.isPackage ? this.props.toggleCartDialog ? "SHOW ITEMS" : "ADD TO CART" : "SHOW CART"}
                            </SpotlioButton>
                        </div>
                    </React.Fragment>
                    }
                </div>
                <Dialog
                    open={this.state.removeItemModal}
                    title={LocaleAsString("cart.remove_item.title")}
                    classname="deleteItem"
                    footerContent={
                        <React.Fragment>
                            {(this.state.deletedItem.Quantity > 1 && this.state.deletedItem.Grouped === true) ?
                                <React.Fragment>
                                    <Button onClick={this.props.deleteFromCart ? ()=>this.bundleDeletePackage(this.state.auxIdx) : ()=>this.handleDeleteItem(this.state.deletedItem.Quantity)} className="secondary">Remove All</Button>
                                    <Button onClick={this.props.deleteFromCart ? ()=>this.bundleDeletePackage(this.state.auxIdx, this.state.amountToDelete) : ()=>this.handleDeleteItem(this.state.amountToDelete)} className="secondary">Remove ({this.state.amountToDelete})</Button>
                                </React.Fragment>  :
                            <Button onClick={this.props.deleteFromCart ? ()=>this.bundleDeletePackage(this.state.auxIdx) : ()=>this.handleDeleteItem()} className="secondary" autoFocus>Remove Product</Button>
                        }
                            <Button onClick={()=>this.removeItemModalOpen({}, false)} className="primary">Keep Item</Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        <div>{this.state.deletedItem.SupplierName}</div>
                        <div>{this.state.deletedItem.ProductName}</div>
                        {
                            (this.state.deletedItem.Quantity > 1 && this.state.deletedItem.Grouped === true)
                            ?
                            <div className="dropdowndelete">
                                {LocaleAsString("cart.remove_item.amount")}
                                <QuantitySelector
                                    showSymbol={'x'}
                                    max={this.state.deletedItem.Quantity}
                                    default={this.state.amountToDelete > 0 ? this.state.amountToDelete : 1}
                                    name="items"
                                    whenChange={(name, value)=>this.setState({amountToDelete: value})}
                                />
                            </div>
                            :
                            null
                        }
                    </div>
                </Dialog>
                <Dialog
                    open={this.state.errorModal}
                    classname="deleteItem"
                    footerContent={
                        <React.Fragment>
                            <Button onClick={()=>this.checkModal(false)} className="primary">Close</Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        Your package is missing required components.
                    </div>
                </Dialog>
                <Dialog
                    open={this.state.differentPackagesDiag}
                    classname="deleteItem"
                    title="Adding a new package to your cart"
                    footerContent={
                        <React.Fragment>
                            <Button onClick={() => this.setState({...this.state, differentPackagesDiag: false})} className="primary">Cancel</Button>
                            <Button onClick={() => this.purgeCart()} className="primary">Replace current package</Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        You already have a package in your cart. Are you sure you want to replace it?
                    </div>
                </Dialog>
                <Dialog
                    open={this.state.errorModal}
                    classname="deleteItem"
                    footerContent={
                        <React.Fragment>
                            <Button onClick={()=>this.checkModal(false)} className="primary">Close</Button>
                        </React.Fragment>
                    }
                >
                    <div className="body">
                        Your package is missing required components.
                    </div>
                </Dialog>
            </React.Fragment>
        );
    };
}

function mapStateToProps(state) {
    return { form: state.form.form }
  }
  
  export default connect(mapStateToProps)(SummaryCart)
